import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import ForDrawing from './drawing'
import ForCode from './code'
import ForLaTeX from './latex'
import ForImage from './image'

export const CommonRender = ({ type, ...props }) => {
  let RenderForType
  switch (type) {
    case ForImage.type:
      RenderForType = ForImage.RenderBase
      break
    case ForCode.type:
      RenderForType = ForCode.RenderBase
      break
    case ForLaTeX.type:
      RenderForType = ForLaTeX.RenderBase
      break
    case ForDrawing.type:
      RenderForType = ForDrawing.RenderBase
      break
    default:
      throw (new Error(`없는 미디어 타입 ${type}`))
  }

  return <RenderForType {...props} />
}

export const CommonThumbnail = ({ type, ...props }) => {
  let ThumbnailForType
  switch (type) {
    case ForImage.type:
      ThumbnailForType = ForImage.ThumbNailBase
      break
    case ForCode.type:
      ThumbnailForType = ForCode.ThumbNailBase
      break
    case ForLaTeX.type:
      ThumbnailForType = ForLaTeX.ThumbNailBase
      break
    case ForDrawing.type:
      ThumbnailForType = ForDrawing.ThumbNailBase
      break
    default:
      throw (new Error(`없는 미디어 타입 ${type}`))
  }

  return <ThumbnailForType {...props} />
}

export const CommonEditor = ({ type, editorRef, ...props }) => {
  let EditorForType
  switch (type) {
    case ForImage.type:
      EditorForType = ForImage.EditDialog
      break
    case ForCode.type:
      EditorForType = ForCode.EditDialog
      break
    case ForLaTeX.type:
      EditorForType = ForLaTeX.EditDialog
      break
    case ForDrawing.type:
      EditorForType = ForDrawing.EditDialog
      break
    default:
      throw (new Error(`없는 미디어 타입 ${type}`))
  }

  return <EditorForType ref={editorRef} {...props} />
}
